import React from 'react'
import Button from 'react-bootstrap/Button';
import { getAuth } from 'firebase/auth';
import { useNavigate } from 'react-router';

import { initializeApp } from "firebase/app";
import firebaseConfig from '../Firebase/firebaseconfig';

function LogOut(props) {

    let auth = null;

    if (props.auth) {
        const app = initializeApp(firebaseConfig());
        auth = getAuth(app);
    } else {
        auth = getAuth(props.app);
    }

    let navigate = useNavigate();

    const handleSignOut = () => {
        auth.signOut();
        document.cookie = "firebaseAuth=; max-age=0; path=/"
        navigate('/login');
    }

    let text = props.icon ? <i className="bi bi-box-arrow-right"></i> : "Sair";

    return (
        <Button onClick={() => handleSignOut()} variant='btn btn-outline-danger btn-sm'>{text}</Button>
    )
}

export default LogOut